NtechApp.MultipleSelectForm = function(selectForm) {
    this._selectForm = selectForm;
    return this;
};

NtechApp.proto(NtechApp.MultipleSelectForm, {
    getFormHtml: function(selectLabel) {
        var html = '';

        html += '<div class="modalForm selectModalForm multipleSelectModalForm">';
        html += '   <div class="formHeader">';
        html += '       ' + selectLabel;
        html += '       <div class="close"><div class="button">close</div></div>';
        html += '   </div>';

        html += '   <div class="formContent withControls">';
        html += '       <div class="scrollableFormContent" data-lockMouseWheelScroll="e"></div>';
        html += '   </div>';

        html += '   <div class="formControls">';
        html += '       <div class="formControl lightControl" data-cancelBut="e">Cancel</div>';
        html += '       <div class="formControl" data-selectBut="e">Select</div>';
        html += '   </div>';

        html += '</div>';

        return html;
    },

    _getHiddenWrap: function() {
        var wrapId = this._selectForm.getSelectInput().attr("data-customSelectId");
        var sel = "[data-customSelectHiddenWrapId=" + wrapId + "]";

        return this._selectForm.getView().parent().find(sel);
    },

    _getHiddenRows: function() {
        return $(this._getHiddenWrap()).find("> div");
    },

    _getHiddenInputs: function() {
        return $(this._getHiddenRows()).find("input[type='hidden']");
    },

    getSelectedVals: function() {
        var inputs = this._getHiddenInputs();
        var vals = [];

        $.each(inputs, function() {
            vals.push($(this).val());
        });

        return vals;
    },

    highlightSelectedOptions: function() {
        var selectedVals = this.getSelectedVals();
        var $form = this._selectForm.getForm();

        $form.find("[data-optionValue]").removeClass("selected");

        for(var i = 0; i < selectedVals.length; i++) {
            var $option = $form.find("[data-optionValue=" + selectedVals[i] + "]");
            $option.addClass("selected");
        }
    },

    afterInsert: function() {
        this.highlightSelectedOptions();
    },

    beforeOn: function() {
        this.highlightSelectedOptions();
    },

    bindEvents: function() {
        var me = this;
        var click = this._selectForm.getClick();
        var $form = this._selectForm.getForm();
        var $selectInput = this._selectForm.getSelectInput();

        click.listen($form, ".selectOption", function(event) {
            var checkMax = false;
            if(NtechApp.dom.hasAttribute($selectInput.get(0), "data-selectMaxOptions")) {
                var checkMax = true;
                var max = parseInt($selectInput.attr("data-selectMaxOptions"), 10);
            }

            var $option = $(event.target);
            if($option.hasClass("selected"))
                $option.removeClass("selected");
            else {
                if(checkMax && (me._getSelectedCount() == max)) {
                    NtechApp.info.on("Please select maximum " + max + " options");
                    return;
                }
                $option.addClass("selected");
            }
        });

        click.listen($form, "[data-cancelBut]", function() {
            me._selectForm.off();
        });

        click.listen($form, "[data-selectBut]", function() {
            me._select();
            me._selectForm.off();
        });
    },

    _getSelectedCount: function() {
        var $form = this._selectForm.getForm();
        var $selectedOptions = $form.find(".selectOption").filter(function() {
            return $(this).hasClass("selected");
        });

        return $selectedOptions.length;
    },

    _select: function() {
        var $form = this._selectForm.getForm();
        var $selectedOptions = $form.find(".selectOption").filter(function() {
            return $(this).hasClass("selected");
        });

        var $hiddenWrap = this._getHiddenWrap();
        this._getHiddenRows().remove();

        var index = 0;
        var selectedLabels = [];
        var selectedVals = [];

        $.each($selectedOptions, function() {
            selectedLabels.push($(this).text());

            var value = $(this).attr("data-optionValue");
            selectedVals.push(value);

            var proto = $hiddenWrap.attr("data-prototype");
            proto = proto.replace(/__name__/g, index);

            var $item = $($.parseHTML(proto));
            $item.find("input[type='hidden']").val(value);

            $hiddenWrap.append($item);
            index++;
        });

        var $selectInput = this._selectForm.getSelectInput();
        if(NtechApp.dom.hasAttribute($selectInput.get(0), "data-selectSingleLine"))
            var sep = ", ";
        else
            var sep = ", \n";

        var val = selectedLabels.join(sep);
        this._selectForm.getSelectInput().val(val);

        $(this._selectForm).trigger(NtechApp.SelectForm.EVENT_OPTION_SELECT, [
            selectedLabels, selectedVals
        ]);
    }
});